(() => {
  function initialize(root) {
    const success = root.querySelector('[data-contact-success]');
    if (success) {
      try {
        if (sessionStorage.getItem('nr-interior-request') === 'true') success.textContent = success.dataset.interiorSuccess;
        sessionStorage.removeItem('nr-interior-request');
      } catch (_) {}
    }
    if (root.dataset.contactInitialized) return;
    const select = root.querySelector('[data-contact-topic-select]');
    if (!select) return;
    root.dataset.contactInitialized = 'true';
    const guides = root.querySelectorAll('[data-contact-guidance]');
    const interior = root.querySelector('[data-contact-interior]');
    const interiorCheck = root.querySelector('[data-contact-interior-check]');
    const interiorDetails = root.querySelector('[data-contact-interior-details]');
    const updateInterior = () => {
      const active = !interior?.hidden && Boolean(interiorCheck?.checked);
      if (interiorDetails) { interiorDetails.hidden = !active; interiorDetails.disabled = !active; }
    };
    interiorCheck?.addEventListener('change', updateInterior);
    const referenceLabel = root.querySelector('[data-contact-reference-label]');
    const update = () => {
      const topic = select.selectedOptions[0]?.dataset.topic || 'other';
      if (interior) { interior.hidden = !['planning', 'b2b'].includes(topic); interior.disabled = interior.hidden; }
      updateInterior();
      guides.forEach(guide => {
        const active = guide.dataset.contactGuidance === topic;
        guide.hidden = !active;
        if (active && referenceLabel) referenceLabel.textContent = guide.dataset.referenceLabel;
      });
    };
    select.addEventListener('change', update);
    root.querySelectorAll('a[data-contact-topic]').forEach(link => {
      link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const option = Array.from(select.options).find(item => item.dataset.topic === link.dataset.contactTopic);
        if (!option) return;
        event.preventDefault();
        select.value = option.value;
        update();
        const heading = root.querySelector('[data-contact-form-heading]');
        root.querySelector('#Kontaktformular').scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start'});
        heading?.focus({preventScroll: true});
      });
    });
    const params = new URLSearchParams(location.search);
    const requestedTopic = params.get('anliegen');
    if (['planning', 'b2b', 'product', 'technical', 'order'].includes(requestedTopic)) {
      const option = Array.from(select.options).find(item => item.dataset.topic === requestedTopic);
      if (option) select.value = option.value;
    }
    root.querySelector('form')?.addEventListener('submit', () => {
      try { sessionStorage.setItem('nr-interior-request', String(Boolean(interiorCheck?.checked && !interior?.disabled))); } catch (_) {}
    });
    update();
  }
  document.querySelectorAll('[data-contact-hub]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-contact-hub]').forEach(initialize);
  });
})();

